var plugin_rtlignore_default = {
  "alignLeft": "IiUXz",
  "textWrapNowrap": "bYXDH",
  "alignRight": "NK-0W",
  "alignCenter": "EFJT4",
  "sizeFullWidth": "qCT6o",
  "renderedInTable": "l-kND",
  "sizeOriginal": "Vglbb",
  "sizeContent": "QGq1d",
  "sizeSmall": "_6nm3b",
  "sizeSmallCenter": "_3-RD0",
  "flex": "_3cE7I",
  "atomic": "_3mtS-",
  "embed": "cYiBs",
  "horizontalScrollbar": "zPhPS",
  "pluginContainerMobile": "t2s-P"
};
export {
  plugin_rtlignore_default as default
};
//# sourceMappingURL=plugin.rtlignore-scss.js.map
